// extracted by mini-css-extract-plugin
module.exports = {"contactLinks":"TeamMemberContactLinks_contactLinks__ri8Cs"};